/**
 * Id that the pre-DBP-4055 markup had on the FRC spec link. The GA event
 * `pdp_click_frc_spec_button` was assumed to come from a GTM click trigger on
 * this id (not verified in the GTM container). The specs link is rendered by
 * basler-components, which does not accept an id prop.
 */
export const FRC_SPEC_BUTTON_ID = 'pdp-frc-spec-button';

const FRC_SPEC_LINK_SELECTOR = '[data-testid="pdp-frc-link"]';

export function ensureFrcSpecButtonId(
  root: ParentNode | null | undefined
): void {
  const link = root?.querySelector(FRC_SPEC_LINK_SELECTOR);
  if (!link || link.getAttribute('id') === FRC_SPEC_BUTTON_ID) {
    return;
  }
  link.setAttribute('id', FRC_SPEC_BUTTON_ID);
}
